'use client';
import { CatInputField } from '@blocks-react/components/InputField';
import { FC, PropsWithChildren } from 'react';
import { CatInputFieldProps } from '../types';
import { useController, useFormContext } from 'react-hook-form';
import { BlocksChangeEvent } from '@blocks-web-components/events';
import clx from 'classnames';

export const RequestServiceContactInput: FC<
  PropsWithChildren<CatInputFieldProps>
> = ({ children, ...inputFieldProps }) => {
  const { control, getValues, setValue } = useFormContext();
  const { name, rules } = inputFieldProps;
  const { field, fieldState } = useController({ name, control, rules });

  const status = fieldState?.error ? 'error' : undefined;
  const note = fieldState?.error?.message;

  const onBlChange = (e: BlocksChangeEvent): void => {
    field.onChange(e);
    setValue(name, e.detail.value);
  };

  return (
    <div className={clx({ 'request-service-error': note })}>
      <CatInputField
        {...inputFieldProps}
        fieldNote={note}
        status={status}
        value={getValues(name) ?? ''}
        onBlChange={onBlChange}
        data-testid="request_service_input"
        data-cs-mask
      />
    </div>
  );
};
